import React, { useContext } from 'react';
import { AssignmentFeedbackForm } from 'domains/assignments/Components/AssignmentFeedbackForm';
import { StructuredActivityCtx, withStructuredActivityContext } from 'domains/structuredActivities/context';
import { structuredActivityStepId } from 'domains/structuredActivities/steps';

const SubmitActivity: React.FC = () => {
  const { onComplete, previewMode } = useContext(StructuredActivityCtx);

  return <AssignmentFeedbackForm onSubmit={onComplete} previewMode={previewMode} />;
};

export default withStructuredActivityContext(SubmitActivity, structuredActivityStepId.submitActivity);
